// Vendor imports
const React = require('react')
const { connect } = require('react-redux')
// Client V2 common imports
const withIsVisible = require('client-v2/common/components/is-visible')
const {
  useEmbeddedPlayerUndiscloseCallback
} = require('client-v2/common/contexts/embedded-player')
// Entry imports
const articleProfileModalActions = require('../state/modal-actions')
const ArticleProfileModal = require('./modal-dumb')

/**
 * Undiscloses any disclosed `EmbeddedPlayer` instance
 * when `currentIndex` or `modalDepth` change.
 *
 * **IMPORTANT** YouTube Compliance:
 * Only one embed can be shown at a time!
 * @param {React.Component} wrappedComponent
 * @returns {React.Component}
 */
function withArticleProfileModalUndiscloseEmbeddedPlayerEffect(wrappedComponent) {
  function WithArticleProfileModalUndiscloseEmbeddedPlayerEffect(props) {
    const { currentIndex, modalDepth } = props
    const prevPropsRef = React.useRef()
    const undiscloseEmbeddedPlayer = useEmbeddedPlayerUndiscloseCallback()
    React.useEffect(
      () => {
        const prevProps = prevPropsRef.current || {}
        if (
          currentIndex !== prevProps.currentIndex ||
          modalDepth !== prevProps.modalDepth
        ) {
          undiscloseEmbeddedPlayer()
        }
        prevPropsRef.current = { currentIndex, modalDepth }
      },
      [ currentIndex, modalDepth, undiscloseEmbeddedPlayer ]
    )
    return React.createElement(wrappedComponent, props)
  }
  if (__DEV__) {
    const PropTypes = require('prop-types')

    WithArticleProfileModalUndiscloseEmbeddedPlayerEffect.propTypes = {
      currentIndex: PropTypes.number,
      modalDepth: PropTypes.number
    }
  }
  return WithArticleProfileModalUndiscloseEmbeddedPlayerEffect
}

function mapStateToProps(state) {
  const modalState = state.articleProfileModal
  if (!modalState) {
    return { isVisible: false }
  }
  return {
    isVisible: true,
    currentIndex: modalState.currentIndex,
    modalDepth: modalState.depth,
    slideCount: modalState.slides.size
  }
}

const mapDispatchToProps = {
  onClose: articleProfileModalActions.hide,
  onSlideRefresh: articleProfileModalActions.currentIndexDidChange,
  onSwipeLeft: articleProfileModalActions.previousSlide,
  onSwipeRight: articleProfileModalActions.nextSlide
}

module.exports = (
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    withIsVisible(
      withArticleProfileModalUndiscloseEmbeddedPlayerEffect(
        ArticleProfileModal
      )
    )
  )
)
